import { render, staticRenderFns } from "./ThanksStep.vue?vue&type=template&id=a46563ac&"
import script from "./ThanksStep.vue?vue&type=script&lang=js&"
export * from "./ThanksStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports